import $ from 'jquery';
import './utils/jquery-events';
import { MainNavigation } from 'tradera/legacy/static/containers/navigation/main-navigation';

export default async () => {
    window.$ = window.$ || $;
    MainNavigation();
};
